/**
 * @file rare-card.component.ts
 * Carte de rareté RARE.
 *
 * Effets visuels :
 * - Dégradé bleu prismatique (#60a5fa → #3b82f6 → #818cf8)
 * - Bordure animée en rotation
 * - Particules bleues ascendantes
 * - Aucun effet paillette/foudre
 *
 * Usage :
 * ```html
 * <app-rare-card [card]="cardData" />
 * ```
 */

import {
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';
import {Card} from '@/app/shared/components/card/card.model';
import {CardComponent} from '@/app/shared/components/card/card.component';

@Component({
  selector: 'app-rare-card',
  standalone: true,
  imports: [CardComponent],
  template: `
    <app-card
      rarity="RARE"
      [name]="card.name"
      [score]="score"
      [rating]="card.rating"
      [image]="card.fileName"
      [backOfCard]="card.extension.cardBack"
      [extensionId]="card.extension.id"
      [initiallyFlipped]="initiallyFlipped"
      [interactive]="interactive"
      [author]="card.author"
    />
  `,
  host: { style: 'display: block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RareCardComponent {
  /** Données complètes de la carte à afficher. */
  @Input({ required: true }) card!: Card;

  /** Score obtenu pour ce tirage — propre à l'instance, pas à la carte. */
  @Input({ required: true }) score!: number;

  /** Si `true`, la carte démarre côté dos. */
  @Input() initiallyFlipped = false;

  /**
   * Si `false`, désactive le tilt souris + halo hover interne de `CardComponent`.
   * Utile quand le survol/zoom est déjà géré par un composant parent
   * (ex. `CardsLayerComponent.enableHoverZoom()` dans l'ouverture de booster),
   * pour éviter deux systèmes de hover concurrents sur le même élément.
   */
  @Input() interactive = true;
}
